// PPTHeroGenericScene.js - Exact original behavior with current levels
import PPTHeroBaseScene from '../PPTHeroBaseScene.js';

export default class PPTHeroGenericScene extends PPTHeroBaseScene {
  constructor() {
    console.log('PPTHeroGenericScene constructor - window.RexPlugins:', window.RexPlugins);
    console.log('PPTHeroGenericScene constructor - window.RexPlugins.UI:', window.RexPlugins?.UI);
    
    super({
      key: 'PPTHeroGenericScene'
    });
  }

  init() {
    // Rex UI will be configured manually in RexUIManager when needed
    super.init();
  }

  // Generic-specific methods can be added here if needed in the future
}
